import Footer from './Footer';
import { SelectLang } from './RightContent';

export { Footer, SelectLang };
